// extracted by mini-css-extract-plugin
module.exports = {"toggleContainer":"styles_toggleContainer__3cJbZ","toggleHandle":"styles_toggleHandle__17UKI","toggled":"styles_toggled__2erwB"};